module.exports = __webpack_public_path__ + "img/banner2_7_vi.aed42f42.png";